import React from 'react';

// 全局 REM 基准设置（建议在入口文件执行，这里内置简化使用）
// if (typeof window !== 'undefined') {
//   const setRemBase = () => {
//     const html = document.documentElement;
//     // 设计稿基准：750px = 100rem（1rem = 7.5px），可根据需求调整
//     const rem = html.clientWidth / 7.5;
//     html.style.fontSize = `${rem}px`;
//   };
//   setRemBase();
//   window.addEventListener('resize', setRemBase);
// }

interface ScoreRatingProps {
  score?: number;
  word?: string;
  maxScore?: number;
  /** 组件大小（单位：rem，基于 750px 设计稿） */
  size?: number;
  startColor?: string;
  endColor?: string;
  textColor?: string;
  bgColor?: string;
}

const ScoreRating: React.FC<ScoreRatingProps> = ({
  score = 65,
  word = '',
  maxScore = 100,
  size = 19.3, // 设计稿 120px → 12rem（基于 750px 设计稿）
  startColor = '#EE6E2F',
  endColor = 'rgba(238, 110, 47, 0.5)',
  textColor = '#EE6E2F',
  bgColor = 'rgba(238, 110, 47, 0.2)',
}) => {
  const ratio = Math.min(Math.max(score / maxScore, 0), 1);
  // 固定 viewBox 为 100x100，内部使用百分比计算位置
  const viewBoxSize = 120;
  const radius = viewBoxSize / 2 - 10; // 圆环半径（留出10px宽度）
  const circumference = 2 * Math.PI * radius;

  return (
    <div className="score-rating" style={{ width: `${size}rem` }}>
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        {/* 背景圆环 */}
        <circle
          cx={viewBoxSize / 2}
          cy={viewBoxSize / 2}
          r={radius}
          fill="none"
          stroke={bgColor}
          strokeWidth="10" // 基于 viewBox 的固定宽度
        />

        {/* 进度圆环 */}
        <circle
          cx={viewBoxSize / 2}
          cy={viewBoxSize / 2}
          r={radius}
          fill="none"
          stroke={`url(#scoreGradient-${size})`}
          strokeWidth="10"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - ratio)}
          transform={`rotate(-90 ${viewBoxSize / 2} ${viewBoxSize / 2})`}
          strokeLinecap="round"
        />

        {/* 渐变定义 */}
        <defs>
          <linearGradient
            id={`scoreGradient-${size}`}
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor={startColor} />
            <stop offset="100%" stopColor={endColor} />
          </linearGradient>
        </defs>

        {/* 分数文本 */}
        <text
          className="score-text"
          x={viewBoxSize / 2}
          y={viewBoxSize / 2 + 3} // 垂直居中微调
          fontSize="50" // 基于 viewBox 的字号
          fontWeight="bold"
          fill={textColor}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {score}
        </text>

        {/* 右侧标识 */}
        <text
          className="score-unit" // 新增类名
          x={viewBoxSize / 2 + 30}
          y={viewBoxSize / 2 + 10} // 垂直居中微调
          fontSize="20" // 基于 viewBox 的字号
          fill={textColor}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {word}
        </text>
      </svg>
    </div>
  );
};

export default ScoreRating;
